import { render, staticRenderFns } from "./BaseAutocompleteProduct.vue?vue&type=template&id=85384e00&scoped=true&"
import script from "./BaseAutocompleteProduct.vue?vue&type=script&lang=js&"
export * from "./BaseAutocompleteProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85384e00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
installComponents(component, {VAutocomplete})
